import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import FIELDS from '../../data/fields';
import { createTypeSolution, updateTypeSolution } from '../../app/store/actions/typeSolution';

class TypeSolutionForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: null,
      editTypeSolution: false,
      isLoading: false,
      description: '',
      messageError: '',
      messageSuccess: '',
    };
  }

  setValue = (att, value) => {
    if (value && value < 0) {
      this.setState({ [att]: Math.abs(value) });
    } else {
      this.setState({ [att]: value });
    }
  }

  goBack = () => {
    this.props.back.goBack();
  };

  createTypeSolution = async () => {
    this.setState({ isLoading: true });
    const {
      description
    } = this.state;

    if(!description){
      this.setState({ messageError: I18n.t('fieldsNotReported') });
      this.setState({ isLoading: false });
      return
    }

    try {
      await this.props.createTypeSolution({
        description
      });

      await this.setState({ messageSuccess: I18n.t('registrationPerformed') });
      await this.goBack();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error
      this.setState({ messageSuccess: '' })

      if (error && error.message) {
        const messageError = (error.code && error.details) ?
          `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({ messageError: messageError })
      } else {
        this.setState({ messageError: I18n.t('errorOcurred') })
      }
    }
    this.setState({ isLoading: false });
  }

  setSelectedTypeSolution = async (selectedTypeSolution) => {
    this.setState({
      editTypeSolution: true,
      id: selectedTypeSolution.id, 
      description: selectedTypeSolution.description,
    });
  }

  updateTypeSolution = async () => {
    this.setState({ isLoading: true });
    const {
      id, description
    } = this.state;
    if(!id || !description){
      this.setState({ messageError: I18n.t('fieldsNotReported') });
      this.setState({ isLoading: false });
      return
    }

    try {
      await this.props.updateTypeSolution({
          id, description
        },
      );

      await this.setState({ messageSuccess: I18n.t('changeMade') });
      await this.goBack();
    } catch (err) {

      const error = err.response && err.response.data && err.response.data.error
      this.setState({ messageSuccess: '' })

      if (error && error.message) {
        const messageError = (error.code && error.details) ?
          `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({ messageError: messageError })
      } else {
        this.setState({ messageError: I18n.t('errorOcurred') })
      }
    }
    this.setState({ isLoading: false });
  }

  componentDidMount = async () => {
    if (this.props.back.location.selectedTypeSolution) {
      await this.setSelectedTypeSolution(this.props.back.location.selectedTypeSolution);
    }
  }

  render() {
    const {
      isLoading, messageSuccess, description, messageError, editTypeSolution,      
    } = this.state;

    return (
      <div className="form-main">
        <h2 className="header-form-client">
          {I18n.t('typeSolutionRegistration')}
        </h2>
        <form>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('description')}
            </p>
            <input
              type="text"
              onChange={e => this.setValue('description', `${e.target.value}`)}
              value={description}
              className="form-control"
              placeholder=""
              maxLength={FIELDS.max}
            />
          </div>             

          {!!messageSuccess && <p className="color-green margin-top-10">{messageSuccess}</p>}
          {!!messageError && <p className="color-red margin-top-10">{messageError}</p>}

          <div className="row margin-left-0 margin-top-10">
            <button
              type="button"
              onClick={() => this.goBack()}
              className="btn btn-warning margin-right-15"
            >
              {I18n.t('return')}
            </button>

            <button
              type="button"
              className="btn btn-dark"
              onClick={() => (!editTypeSolution) ? this.createTypeSolution() : this.updateTypeSolution()}
              disabled={isLoading}
            >
              {(!editTypeSolution) ? I18n.t('toSend') : I18n.t('resend')}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
    createTypeSolution: (newTypeSolution) => dispatch(createTypeSolution(newTypeSolution)),
    updateTypeSolution: (updTypeSolution) => dispatch(updateTypeSolution(updTypeSolution)),
});

const mapStateToProps = state => ({
});


export default connect(mapStateToProps, mapDispatchToProps)(TypeSolutionForm);
